export default __webpack_public_path__ + "static/media/dashboardArtBoardPlaceholder.cb40072e.png";